module.exports = __webpack_public_path__ + "img/nate2.c5476288.jpg";